import {initStore} from './store';

const configureStore = () => {
    const actions = {
        SET_WINDOWWIDTH: (curState, windowWidth) => {
            return {isMobile: windowWidth < 768};
        }
    };
    initStore(actions);
};

export default configureStore;
